import { useMutation } from '@tanstack/react-query';
import { request } from '../../actions/helper';
import { CHECKR_BFF_API_BASE } from '../../constants';

export interface PiiDeletionRequest {
  candidate_ids?: string[];
  contact_email?: string;
  contact_name?: string | null;
  international: boolean;
}

const createOptions = ({
  candidate_ids,
  contact_email,
  contact_name,
  international,
}: PiiDeletionRequest) => ({
  method: 'POST',
  body: JSON.stringify({
    candidate_ids,
    contact_email,
    // The BFF needs a name for the ticket; fall back to the email.
    contact_name: contact_name || contact_email,
    international,
  }),
});

// Domestic candidates never raise a deletion ticket from here.
export const requestPiiDeletion = (userInfo: PiiDeletionRequest) =>
  userInfo.international
    ? request(
        `${CHECKR_BFF_API_BASE}/privacy/delete-request/candidate`,
        createOptions(userInfo),
      )
    : Promise.resolve();

// ECDEX-3840 (slice 2): the delete-my-data request. Replaces the
// privacy.deletionRequest Redux state; pending, success and error state now
// belong to the component that submits it.
const usePiiDeletion = () => useMutation({ mutationFn: requestPiiDeletion });

export default usePiiDeletion;
